module.exports = __webpack_public_path__ + "static/media/time_box.24ea6dd4.png";